import React, { useState } from 'react';
import { arrayOf, bool, func, node, number, shape, string } from 'prop-types';
import Avatar from '@magalu/stereo-ui/molecules/Avatar';
import Carousel from '@magalu/stereo-ui/molecules/Carousel';
import MediaReviewCard from '@magalu/stereo-ui/molecules/MediaReviewCard';
import Review from '@magalu/stereo-ui/molecules/Review';
import ProductReviewGallery from '@magalu/stereo-ui/organisms/ProductReviewGallery';
import { ExchangeCircle } from '@magalu/stereo-ui-icons';
import { DialogStyled, SeeMore, ReviewWrapper, Description, ModalDetailsBody, CaroulselBlock, ReviewContainer, Header, ReviewerName, SubTitle, DateWrapper, CondensedMediasBlock, DialogContent, RotateButton, RotateButtonBlock } from './web-review-popup.styles';
import { formatSubtitle, generateDateDistance, reduceDescription, validateShortDescription } from '../../helpers';
const modalTitleStyle = {
  color: '#51585C',
  fontWeight: 'bold'
};

const WebReviewPopup = ({
  changeCaroulsel,
  charLimit,
  children,
  closePopup,
  review,
  selectedMedia,
  thumbnails,
  showRotateButton,
  onRotateImage
}) => {
  const [seeMore, setSeeMore] = useState(false);
  const [selectedCondensedMedia, setSelectedCondensedMedia] = useState(selectedMedia);
  const {
    rating,
    description,
    submissionDate,
    attributes,
    userData
  } = review;
  const isShortDescription = validateShortDescription(description, charLimit);
  const reducedDescription = reduceDescription(description, charLimit);
  const days = generateDateDistance(submissionDate);
  const subtitle = formatSubtitle(attributes);

  const renderGallery = () => {
    const renderedCards = thumbnails.map((media, index) => {
      return /*#__PURE__*/React.createElement(MediaReviewCard, {
        key: `caroulsel-card-${media.mediaUrl}`,
        media: media,
        onClick: () => setSelectedCondensedMedia(index)
      });
    });
    return /*#__PURE__*/React.createElement(ProductReviewGallery, null, renderedCards);
  };

  return /*#__PURE__*/React.createElement(DialogStyled, {
    position: "center",
    showClose: true,
    type: "responsive",
    onClickOutside: closePopup,
    title: "Avalia\xE7\xF5es com m\xEDdias",
    titleStyle: modalTitleStyle
  }, /*#__PURE__*/React.createElement(DialogContent, {
    flexDirection: "column",
    justifyContent: "space-between"
  }, /*#__PURE__*/React.createElement(ModalDetailsBody, null, /*#__PURE__*/React.createElement(CaroulselBlock, {
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(Carousel, {
    showSlideCount: true,
    showArrowControls: true,
    showControls: false,
    auto: false,
    goTo: selectedCondensedMedia,
    verticalAlign: 'center',
    onChange: changeCaroulsel
  }, children), /*#__PURE__*/React.createElement(RotateButtonBlock, {
    justifyContent: "center",
    alignItems: "center"
  }, showRotateButton && /*#__PURE__*/React.createElement(RotateButton, {
    variation: "outline",
    size: "small",
    onClick: onRotateImage,
    startIcon: /*#__PURE__*/React.createElement(ExchangeCircle, {
      width: 20,
      height: 20
    }),
    centered: true
  }, "Girar imagem"))), /*#__PURE__*/React.createElement(ReviewContainer, {
    container: true
  }, /*#__PURE__*/React.createElement(Header, null, /*#__PURE__*/React.createElement(Avatar, null), /*#__PURE__*/React.createElement(ReviewerName, null, userData.name), /*#__PURE__*/React.createElement(ReviewWrapper, null, /*#__PURE__*/React.createElement(Review, {
    score: rating
  }))), subtitle.length > 0 && /*#__PURE__*/React.createElement(SubTitle, {
    "data-testid": "review-sub-title"
  }, subtitle), /*#__PURE__*/React.createElement(Description, {
    "data-testid": "review-description"
  }, seeMore || isShortDescription ? description : reducedDescription, "\xA0", !isShortDescription && /*#__PURE__*/React.createElement(SeeMore, {
    onClick: () => setSeeMore(!seeMore),
    role: "button"
  }, !seeMore ? 'ver mais' : 'ver menos')), days && /*#__PURE__*/React.createElement(DateWrapper, {
    "data-testid": "review-date"
  }, `há ${days}`))), /*#__PURE__*/React.createElement(CondensedMediasBlock, null, renderGallery())));
};

process.env.NODE_ENV !== "production" ? WebReviewPopup.propTypes = {
  charLimit: number,
  children: node,
  closePopup: func,
  review: shape({
    rating: number,
    description: string,
    submissionDate: string,
    dimensionDefs: arrayOf(string),
    userData: shape({
      name: string
    })
  }),
  selectedMedia: number,
  changeCaroulsel: func,
  thumbnails: arrayOf(shape({
    mediaUrl: string,
    mediaType: string
  })),
  showRotateButton: bool,
  onRotateImage: func
} : void 0;
WebReviewPopup.defaultProps = {
  charLimit: 110,
  reviewDate: null,
  subtitle: ''
};
export default WebReviewPopup;